<template>
  <template
    v-for="(node, index) in nodes"
    :key="index"
  >
    <br v-if="node.type === 'hardBreak'">
    <nuxt-link
      v-else-if="linkHref(node)"
      :to="наЯзыке(linkHref(node))"
      :class="linkClass(node)"
    >{{ node.text }}</nuxt-link>
    <span
      v-else
      :class="markClasses(node)"
    >{{ node.text }}</span>
  </template>
</template>

<script setup lang="ts">
/**
 * Строка текста юридического документа: ссылки, переносы и начертания.
 *
 * Вынесено из LegalDocumentView, потому что то же самое нужно рисовать в двух
 * местах — в абзаце и в пункте списка. Держать две копии значит однажды
 * починить только одну из них.
 */
type TiptapMark = { type?: string, attrs?: Record<string, unknown> }

type TiptapNode = {
  type: string
  text?: string
  marks?: TiptapMark[]
  attrs?: Record<string, unknown> | null
  content?: TiptapNode[]
}

defineProps<{ nodes: TiptapNode[] }>()

const localePath = useLocalePath()

/**
 * Ссылки из текста документа — на текущем языке.
 *
 * В содержимом адреса записаны без языка ('/regulations/…'), и с английской
 * версии документа такая ссылка уводила на русскую. Якоря и внешние адреса
 * не трогаем: у якоря нет языка, у чужого сайта — наших маршрутов.
 */
const наЯзыке = (href: string | null): string | null => {
  if (!href || !href.startsWith('/') || href.startsWith('//')) return href
  return localePath(href) || href
}

const linkHref = (node: TiptapNode): string | null => {
  const mark = (node.marks ?? []).find(m => m?.type === 'link')
  const href = mark?.attrs?.href
  return typeof href === 'string' && href ? href : null
}

/**
 * Ссылки на странице двух видов, и это не косметика: пункты оглавления
 * фиолетовые, а ссылки внутри текста — белые с подчёркиванием. Вид
 * приходит из содержимого, потому что так свёрстана прежняя страница.
 */
const linkClass = (node: TiptapNode): string => {
  const mark = (node.marks ?? []).find(m => m?.type === 'link')
  return mark?.attrs?.underline ? 'underline' : 'section__link'
}

const markClasses = (node: TiptapNode): string[] => {
  const classes: string[] = []
  for (const mark of node.marks ?? []) {
    if (mark?.type === 'bold') classes.push('font-semibold')
    if (mark?.type === 'italic') classes.push('italic')
    if (mark?.type === 'underline') classes.push('underline')
  }
  return classes
}
</script>
